import { useSelector } from "react-redux";
import ConsignStep from "./components/consign.step";
import ConsignWhy from "./components/consign.why";
import InspectionModal from "./modals/inspection.modal";

export default function Consign() {
  const { isOpenInspectionModal } = useSelector((state) => state.modal);

  return (
    <>
      <article className="consign">
        <ConsignStep />
        <ConsignWhy />
        {isOpenInspectionModal && <InspectionModal />}
      </article>
    </>
  );
}
